import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private authSvc: AuthService,
              private router: Router) { }

  ngOnInit() {
    if (this.authSvc.isLoggedIn()){
      this.navigateToDashboard();
    }
  }

  login(){
    this.navigateToDashboard();
  }

  navigateToDashboard(){
    this.router.navigate(['/dashboard']);
  }

  reloadPage() {
    window.location.reload();
  }

}
